// @flow
import * as React from 'react';
import { useParams } from 'react-router-dom';
import {
  PageTitle
} from '../../../shared';
import { Box } from '@mui/material';

export const Goals = () => {
  const {agentId} = useParams<{ agentId?: string }>();


  return (
    <Box mt={2}>
      <PageTitle title={`Goals & Metrics`} />

      <iframe width="100%"
              src="https://lookerstudio.google.com/embed/reporting/564f0c20-914f-49fb-9de2-008c6281600c/page/57TrD"
              frameBorder="0"
              style={{ border: 0, minHeight: 1200 }}
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
    </Box>
  );
};
